import React, { useContext } from "react";
import { SettingsBannerContext } from '../../../contexts/SettingsBannerContext';
import { MasterBannerContext } from '../../../contexts/MasterBannerContext';
import LockIcon from '@mui/icons-material/Lock';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward';
import ComboBox from '../../ComboBox';
import './index.css';

export default function Element(item) {
  const { layerActive, setLayerActive } = useContext(SettingsBannerContext);
  const { master, setMaster } = useContext(MasterBannerContext);
  const layer = item.layer;
  const lastStep = master ? master.elements[master.elements.length - 1].step : null;
  const stepColors = ["#AE56A5", "#E28F57", "#E55581", "#7DE5B8", "#1B9ADA", "#e1eb34", "#e1eb34", "#eba534"];
  const listSteps = (ev) => {
    const array = [];
    const lastStep = master.elements[master.elements.length - 1].step;
    for (var i = ev + 1; i <= lastStep; i++) {
      array.push(i - 1);
    }
    return array;
  }

  function ChangeLayer(layer) {
    setLayerActive([{element: layer, type: "in"}]);
  }

  function ChangeIndex(item) {
    if (item.stepout === 0) return;
    var masterCopy = JSON.parse(JSON.stringify(master));

    var index = masterCopy.elements.map(function(e) { return e.id; }).indexOf(item.id);

    if (index === -1) return;

    masterCopy.elements[index].properties.zIndex = masterCopy.elements[index].properties.zIndex <= 1 ? 999 : 1;
    setMaster(masterCopy);
    ChangeLayer(item);
  }
  
  function ChangeFixo(item) {
    if (item.stepout === 0) return;
    var masterCopy = JSON.parse(JSON.stringify(master));

    var index = masterCopy.elements.map(function(e) { return e.id; }).indexOf(item.id);

    if (index === -1) return;

    masterCopy.elements[index].fixo = !masterCopy.elements[index].fixo;
    masterCopy.elements[index].out = !masterCopy.elements[index].fixo;

    if (masterCopy.elements[index].fixo) {
      var aux = masterCopy.elements[index].animation.out.delay;
      masterCopy.elements[index].animation.out.delay = masterCopy.elements[index + 1].animation.out.delay;
      masterCopy.elements[index + 1].animation.out.delay = aux;
    } else {
      aux = masterCopy.elements[index].animation.out.delay;
      masterCopy.elements[index].animation.out.delay = masterCopy.elements[index + 1].animation.out.delay;
      masterCopy.elements[index + 1].animation.out.delay = 0.1;
    }
    setMaster(masterCopy);
    ChangeLayer(item);
  }

  function ChangeElementOut(evt, item) {
    try {
      var masterCopy = JSON.parse(JSON.stringify(master));
  
      var index = masterCopy.elements.map(function(e) { return e.id; }).indexOf(item.id);
      
      var step = parseInt(evt) + 1;
      if (index === -1 ) return;
  
      var stepOut = masterCopy.elements[index].stepout;
      masterCopy.elements[index].stepout = step;

      if (index === 0 || masterCopy.elements[index - 1].step !== masterCopy.elements[index].step) {
        for (var i = 0; i < masterCopy.elements.length; i++) {
          if (masterCopy.elements[i].stepout === stepOut) {
            masterCopy.elements[i].animation.out.delay = masterCopy.elements[index].animation.out.delay;
            break;
          }
        }

        for (var t = 0; t < masterCopy.elements.length; t++) {
          if (masterCopy.elements[t].stepout === masterCopy.elements[index].stepout && masterCopy.elements[t].id !== masterCopy.elements[index].id) {
            masterCopy.elements[t].animation.out.delay = 0.1;
            break;
          }
        }
      } else {
        for (var w = 0; w < masterCopy.elements.length; w++) {
          if (masterCopy.elements[w].stepout === masterCopy.elements[index].stepout && masterCopy.elements[w].id !== masterCopy.elements[index].id) {
            masterCopy.elements[index].animation.out.delay  = masterCopy.elements[w].animation.out.delay;
            masterCopy.elements[w].animation.out.delay = 0.1;
            break;
          }
        }
      }
      setMaster(masterCopy);
  } catch (error) { }
  }

  return (
    <div
      onContextMenu={() => item.onClick()}
      style={{width: layer.parent ? '90%' : '100%', display: 'flex', flexDirection: 'row',
      backgroundColor: layerActive.length === 1 && layerActive[0].element === layer ? 'transparent': 'transparent', borderRadius: '28px'
      }}
    >
      <div
        style={{background: '#FFFFFF', marginRight: '10px', position: 'relative'}}
        onClick={() => ChangeLayer(layer)}
        className={layerActive.length === 1 && layerActive[0].element === layer ? "botao_layer botao_focus" : "botao_layer"}>
        <div style={{position: 'absolute', width: '12px', height: '12px',
          background: stepColors[layer.step - 1], borderRadius: '8px', left: layerActive.length === 1 && layerActive[0].element === layer ? '10px': '5px'}}/>
        <span className="layer-span">{layer.id}</span>
        <ArrowUpwardIcon
          fontSize="small"
          color={layer.properties.zIndex > 1 ? "success" : "disabled"}
          style={{cursor: 'pointer', position: 'absolute', right: layerActive.length === 1 && layerActive[0].element === layer ? '24px': '20px'}}
          onClick={() => ChangeIndex(layer)}
        />
        <LockIcon
          fontSize="small"
          style={{display: !layer.parent ? 'flex' : 'none', cursor: 'pointer', position: 'absolute', right: layerActive.length === 1 && layerActive[0].element === layer ? '3px': '-1px'}}
          color={layer.fixo && layer.step !== lastStep ? "primary" : "disabled"}
          onClick={() => ChangeFixo(layer)}          
        />
        <div style={{display: layer.step === lastStep ? 'block' : 'none',  position: 'absolute', right: '8px', top: '6px'}}>
          <svg
            style={{ width: '20px', height: '20px'}}
            xmlns="http://www.w3.org/2000/svg" 
            version="1.1">
            <line
              x1="0" x2="20"
              y2="0" y1="20" 
              style={{stroke: 'red' }} />
          </svg>
        </div>
      </div>
      <div style={{ display: 'flex', alignItems: 'center'}}>
        <ComboBox
          width="55px"
          height="29px"
          maxHeight="78px"
          placeholder={layer.step === lastStep  ? "-" : layer.stepout === 0 ? "" : parseInt(layer.stepout - 1).toString()} 
          list={layer.step >= lastStep - 1 ? null : listSteps(layer.step)} 
          onChange={(evt) => ChangeElementOut(evt, layer)}
          active={layer.parent ? false : true}
          />
      </div>
    </div>
  )
}